import styles from './CoachDashboardStats.module.scss'
import StatsItemPopover from './StatsItemPopover'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const StatsItem = ({ icon, yards, golfers, division }) => {
  const { t } = useTranslation()

  return (
    <>
      <div className={styles.statsItem} id={`Popover-${division}`}>
        {icon}
        <div>
          <div className={styles.level}>{t('dashboard.coach.statsItem.level', { division })}</div>
          <div className={styles.yards}>{t('dashboard.coach.statsItem.yards', { yards })}</div>
        </div>
        <div className={styles.statsCount}>
          {golfers?.length}
        </div>
      </div>
      {golfers?.length > 0 &&
        <StatsItemPopover divisionId={division} golfers={golfers}/>
      }
    </>
  )
}

StatsItem.propTypes = {
  icon: PropTypes.element,
  yards: PropTypes.string,
  golfers: PropTypes.array,
  division: PropTypes.number,
}


export default StatsItem
